type SearchSlice = {
    recentSearches: string[];
    setRecentSearches: (newPhrase: string) => void;
    // TODO: complete typescript
    appliedFilters: any;
    setAppliedFilters: (newAppliedFilters: any) => void;
}

const createSearchSlice = (set: any): SearchSlice => ({
    // TODO: might recentSearches be braught to the page component?
    recentSearches: (typeof window !== 'undefined' && localStorage?.getItem('recentSearches')) ? JSON.parse(localStorage.getItem('recentSearches')) : [],
    setRecentSearches: (newPhrase) => {
        if (!newPhrase) {
            return;
        }

        set((state) => {
            const index = state.recentSearches?.indexOf(newPhrase);

            if (index !== -1) {
                state.recentSearches.splice(index, 1);
            }

            state.recentSearches.push(newPhrase);

            localStorage.setItem('recentSearches', JSON.stringify(state.recentSearches));

            return { recentSearches: state.recentSearches };
        });
    },
    appliedFilters: {},
    setAppliedFilters: (newAppliedFilters) => {
        set(() => ({ appliedFilters: newAppliedFilters }));
    }
});

export default createSearchSlice;